import type { AssetTypeTemplateDeleteButtonProps } from "./asset-type-template-delete-button.type";

import ModelDeleteButton from "@/modules/model-delete-button";

import { useAssetTypeTemplateDeleteButton } from "./asset-type-template-delete-button.hook";

export const AssetTypeTemplateDeleteButton = ({
  entityTemplate,
  ...buttonProps
}: AssetTypeTemplateDeleteButtonProps) => {
  const { isDeletable, tooltip } = useAssetTypeTemplateDeleteButton({
    entityTemplate,
  });

  return (
    <ModelDeleteButton
      modelKey="technicalform"
      item={entityTemplate}
      tooltip={tooltip}
      disabled={!isDeletable}
      authorizeRender={!isDeletable ? "disabled" : "hidden"}
      {...buttonProps}
    />
  );
};
